import { render, staticRenderFns } from "./BaseHeaderRastreabilidade.vue?vue&type=template&id=53c5683e&scoped=true&lang=pug"
import script from "./BaseHeaderRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BaseHeaderRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderRastreabilidade.vue?vue&type=style&index=0&id=53c5683e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5683e",
  null
  
)

export default component.exports